/**
 * Safely convert a value to a finite number, returning 0 for NaN/Infinity/null/undefined.
 */
export function safeNum(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

/**
 * Safely divide two numbers, returning 0 when the divisor is 0 or non-finite.
 */
export function safeDiv(numerator, denominator) {
  const num = safeNum(numerator);
  const den = safeNum(denominator);
  if (den === 0) return 0;
  return num / den;
}

/**
 * 최대 나머지법: 개별 항목을 반올림해도 합계가 정확히 맞도록 조정한다.
 * @param {number[]} values - 원본 (소수 포함) 값 배열
 * @param {number} [targetTotal] - 합계 목표값. 생략하면 values 합계를 반올림
 * @returns {number[]} 반올림 조정된 정수 배열 (합계 === Math.round(targetTotal))
 */
export function largestRemainder(values, targetTotal) {
  if (!values || values.length === 0) return [];
  const target = Math.round(targetTotal != null ? targetTotal : values.reduce((a, b) => a + b, 0));
  const floored = values.map(v => Math.floor(v));
  let diff = target - floored.reduce((a, b) => a + b, 0);
  if (diff === 0) return floored;
  const indexed = values.map((v, i) => ({ i, remainder: v - Math.floor(v) }));
  indexed.sort((a, b) => b.remainder - a.remainder);
  for (let j = 0; j < Math.abs(diff) && j < indexed.length; j++) {
    floored[indexed[j].i] += diff > 0 ? 1 : -1;
  }
  return floored;
}

/**
 * 정산 세금(국세/지방세) 표시·저장용 절사.
 * 소수점은 반올림하고, 일의 자리(1~9원)는 절사하여 10원 단위로 끊는다.
 *  - truncateToTenWon(1234.4)  → 1230
 *  - truncateToTenWon(1235.6)  → 1230  (round 1236 → trunc 1230)
 *  - truncateToTenWon(-1234)   → -1230 (Math.trunc 로 0 방향)
 */
export function truncateToTenWon(value) {
  const n = safeNum(value);
  return Math.trunc(Math.round(n) / 10) * 10;
}
